import React, {useState} from "react";
import {
  Box,
  Button, Card, CardActions,
  CardContent, CardHeader, Chip, CircularProgress
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormTabsNavigation from "../FormTabsNavigation";
import useEffectExceptOnMount from "../../../../helpers/useEffectExceptOnMount";


const FormTabs = ({
                      navigations,
                      isEditing,
                      userMadeChanges,
                      setUserMadeChanges,
                      setClickOnArrowBack,
                      onSave,
                      disabledSave,
                      disabledSaveReason,
                      isLastStep,
                      Stepper,
                      CustomActions,
                      FooterActions,
                      children,
                      actionsLayout='bottom',
                      hasError,
                      pmUpdated,
                      hideSave,
                  }) => {

    const [saving, setSaving] = useState(false)

    useEffectExceptOnMount(() => {
        if(saving && !userMadeChanges) {
            setSaving(false)
        }
    }, [userMadeChanges])

    useEffectExceptOnMount(() => {
        if (hasError) {
            setSaving(false)
        }
    }, [hasError])

    const calculateHistory = () => {
        return navigations.slice(0, navigations.length - 1);
    }

    const getActiveBreadcrumbItem = () => {
        return navigations[navigations.length - 1];
    }

    const handleSave = async (event) => {
        setSaving(true)
        await onSave(event)
        setSaving(false)
    }

    return (
        <>
                    <Card className="admin-form-tabs">
                        <CardHeader className="card-header"
                                    title={
                                        <Box className="card-header-content">
                                            <FormTabsNavigation history={calculateHistory()}
                                                                userMadeChanges={userMadeChanges}
                                                                setUserMadeChanges={setUserMadeChanges}
                                                                setClickOnArrowBack={setClickOnArrowBack}
                                                                active={getActiveBreadcrumbItem()}
                                                                hasError={hasError || disabledSave}/>

                                            {pmUpdated && <Chip label="PM Update" size="small" className="event-chip success" style={{marginLeft: '2rem'}}/>}

                                            { isEditing ? (
                                                CustomActions
                                            ) : (
                                                Stepper
                                            ) }

                                            <Box className="card-header-submit">
                                                {
                                                    isEditing && !hideSave ? <Tooltip title={disabledSaveReason || ""} arrow placement="top">
                                                        <span>
                                                            <Button
                                                                className={isEditing ? "secondary" : "create"}
                                                                variant="contained"
                                                                onClick={handleSave}
                                                                disabled={isEditing ? !userMadeChanges || disabledSave || saving : !userMadeChanges || disabledSave || !isLastStep || saving}
                                                                style={{ position: 'relative' }}
                                                            >
                                                                {saving && (
                                                                    <CircularProgress style={{ height: '20px', width: '20px', position: 'absolute' }} />
                                                                )}
                                                                <span style={{ visibility: saving ? 'hidden' : 'visible' }}>
                                                                    {isEditing ? "Save changes" : "Create"}
                                                                </span>
                                                            </Button>
                                                        </span>
                                                    </Tooltip> : <>
                                                        {
                                                            (!!FooterActions && actionsLayout === 'top') && FooterActions
                                                        }
                                                    </>
                                                }
                                            </Box>
                                        </Box>
                                    }
                        />
                        <CardContent className="card-content">
                            <Box className="section">
                                {children}
                            </Box>
                        </CardContent>
                        {
                            (!!FooterActions && actionsLayout === 'bottom') &&
                            <CardActions className="card-actions">
                                <Box className="section">
                                    {FooterActions}
                                </Box>
                            </CardActions>
                        }
                    </Card>
        </>
    )
}

export default FormTabs;